function DashboardHome({ children }: any) {
  return (
    <>
      <h2>Well Hello there</h2> {children}
    </>
  );
}

export default DashboardHome;
